import { createSlice } from "@reduxjs/toolkit";
import { getListRewardType } from "../../api/rewardType/rewardType";

// giá trị khởi tạo của state
const initialState = {
    listRewardTypes: [],
    isLoadRewardTypes: false,
    currentPage: 1,
    pageSize: 10,
    hasFetchedData: false,
    error: null,

};

const rewardTypeSlice = createSlice({
    name: "rewardTypes", // tên phân biệt giữa các reduce
    initialState,
    reducers: {
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setPageSize: (state, action) => {
            state.pageSize = action.payload;
        },
        setHasFetchedData: (state, action) => {
            state.hasFetchedData = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getListRewardType.pending, (state) => {// api đnag pending chờ xử lý
                state.isLoadRewardTypes = true;
                state.error = null;
            })
            .addCase(getListRewardType.fulfilled, (state, action) => {// api trả về thành công thì trả ra
                state.isLoadRewardTypes = false;
                state.listRewardTypes = action.payload.data || [];

                state.isLoadRewardTypes = false;
                state.hasFetchedData = true;
            })
            .addCase(getListRewardType.rejected, (state, action) => {// api trả về thất bại thì trả ra
                state.isLoadRewardTypes = false;
                state.error = action.payload;
            });
    },
});

export const { setCurrentPage, setPageSize, setHasFetchedData } = rewardTypeSlice.actions;
export default rewardTypeSlice.reducer;
